import 'css-chunksrc/client/pages/projectPage/exportsPage/wbsReport/filters/styles.scss';export default {
  "filters": "_filters_p86yv_1",
  "resetButton": "_resetButton_p86yv_17",
  "label": "_label_p86yv_25",
  "section": "_section_p86yv_32"
};